import { datadogRum } from '@datadog/browser-rum';

const URLS_TO_SOURCE = {
  'cdn/apps/prod/global-markup/': 'global-markup',
  'cdn/apps/prod/compass/': 'compass',
};

export const initDDRum = () => {
  if (
    typeof window === 'undefined' &&
    process.env.NEXT_PUBLIC_ENABLE_DATADOG_RUM
  )
    return;

  datadogRum.init({
    applicationId: '9ba64223-f8c7-4fc3-a949-f648f9499137',
    clientToken: 'pub25f8001b653129913556274aba5ca97c',
    site: 'datadoghq.com',
    service: 'cardfinder',
    env:
      window.location.host.match('nerdwallet.com') !== null ? 'prod' : 'stage', //process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 5,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    version: process.env.NEXT_PUBLIC_DEPLOYABLE_VERSION,
    beforeSend: (event) => {
      if (event.type === 'error') {
        if (shouldDiscard(event.error)) {
          return false;
        }
        Object.entries(URLS_TO_SOURCE).map(([key, value]) => {
          if (event.error.stack && event.error.stack.includes(key)) {
            event.context = { ...event.context, nw_source: value };
          }
        });
      }
    },
  });

  datadogRum.startSessionReplayRecording();
};

/**
 *
 * @param {RumErrorEvent["error"]} error
 * @returns true if we should discard this error, false otherwise
 */
const shouldDiscard = (error) => {
  if (
    error.source === 'console' &&
    error.stack &&
    (error.stack.includes('accounts.google.com/gsi/client') ||
      error.stack.includes('[GSI_LOGGER]'))
  ) {
    //
    return true;
  }

  if (
    error.source === 'console' &&
    error.handling_stack &&
    (error.handling_stack.includes('accounts.google.com/gsi/client') ||
      error.handling_stack.includes('[GSI_LOGGER]'))
  ) {
    return true;
  }

  if (error.source === 'console' && error.message.includes('[GSI_LOGGER]')) {
    return true;
  }

  return false;
};
